export default __webpack_public_path__ + "static/media/pipe-top.3e4cf42d.png";